import styles from './SearchPreview.module.css';
import { LinkComponent } from '../../Links/LinkComponent';

import { useSearchHook, useLanguageHook, useRoutingHook, useRetailerHook } from '../../../Hooks/use-context-hooks';

import { SearchPreviewCard } from '../../ProductCards/SearchPreview/SearchPreviewCard';
import { PageText } from '../../Text/Text';
import { Button } from '../../Button/Button';
import { NavSearchPreviewCard } from '../../ProductCards/NavSearchPreviewCard/NavSearchPreviewCard';
import { useResponsiveStateHook } from '../../../Hooks/responsive-hook';
import { useLinkConfig } from '../../../config/use-links-config';
import { SearchFeedback } from './SearchFeedback';
import { motion } from 'framer-motion';

const listVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.1 // Adjust for timing between children
        }
    }
};

const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
};


export const SearchPreview = () => {

    const { navCategoryLinks } = useLinkConfig();
      const { isHomeDepotApp } = useRetailerHook();
    const { language, translatedText } = useLanguageHook();
    const { isRoutingState, setIsRoutingState } = useRoutingHook();
    // console.log(translatedText)
    const { isMobileSearchState, setIsMobileSearchState, isDesktopSearchState } = useSearchHook();
 
    const prefix = isHomeDepotApp.isHomeDepotPrefix || '';
 
    const handleLinkClick = () => {
        setIsMobileSearchState(prevState => ({
            ...prevState,
            isMobileSearch: false,
        }))
        setIsRoutingState(prevState => ({
            ...prevState,
            isMobileNavOpen: false,
            isCategoriesMenuOpen: false,
            isResourcesMenuOpen: false,
            isAccountMenuOpen: false,
            isBuilderDropdownOpen: false,
            isMobileBuilderDropdownOpen: false,
            isExclusiveMenuOpen: false,
            isNavLinkClicked: true,
        }))

    }


    if (isMobileSearchState.isMobileSearch === true) {
        return (
            isMobileSearchState.isSearchResults.length > 0 ? (
                <div className={styles.searchPreviewWithResults}>
                    <div className={styles.searchPreviewWithResultsInnerDiv}>

                        <SearchPreviewCard products={isMobileSearchState.isSearchResults && isMobileSearchState.isSearchResults} />
                    </div>
                </div>
            ) : (
                <div className={styles.searchPreview}>

                    <div className={styles.previewSectionBody}>

                        <div className={styles.searchPreviewSectionTitleWraper}>
                            <PageText type='productCardSubtitle'>{translatedText.allCategoriesTitles}</PageText>
                        </div>

                        <motion.div
                            variants={listVariants}
                            initial="hidden"
                            animate="visible"
                            className={styles.searchOptionButtonWrapper}

                        >

                            {navCategoryLinks.map(({href, text}) =>
                            {
                               
                                const t = translatedText[text.toLowerCase().replace(/ /g, '')]
                                 console.log(t)
                                return(
                                     <motion.span
                                    onClick={handleLinkClick}
                                    whileHover={{ scale: 1.05 }}
                                    whileTap={{ scale: 0.95 }}
                                    transition={{ type: "spring", stiffness: 300, damping: 15 }}
                                    variants={itemVariants}
                                    key={`${text}`+1}>
                                    <LinkComponent href={`${prefix}${href}`}>
                                        <Button buttonStyleType="primary">
                                            {translatedText[text.toLowerCase().replace(/ /g, '')] || text}
                                            </Button>
                                    </LinkComponent>
                                </motion.span>
                                )
                            }
                               
                            )}



                        </motion.div>
                    </div>

                </div>
            )
        );
    }
    if (isDesktopSearchState.isDesktopSearch === true) {
        return (
            <motion.div
                variants={listVariants}
                initial="hidden"
                animate="visible"
                className={styles.searchPreviewDesktopMainContainer}
                style={{ borderBottom: isDesktopSearchState.isSearchResults.length > 0 ? '1px solid var(--color-gray-04)' : undefined }}
            >
                {
                    isDesktopSearchState.isSearchResults.length > 0 ? (
                        <motion.div
                            variants={itemVariants}
                            className={styles.desktopSearchPreviewWithResultsWrapper}>
                            <div
                                className={styles.desktopSearchPreviewWithResultsInnerDiv}>
                                <NavSearchPreviewCard products={isDesktopSearchState.isSearchResults && isDesktopSearchState.isSearchResults} />
                            </div>
                        </motion.div>
                    ) : isDesktopSearchState.isSearchInputValue.length > 2 && isDesktopSearchState.isSearchResults.length === 0 ?
                        <SearchFeedback
                            feedback="No results. Try searching with different keywords, like model title (S5MSB) or home appliance category (Laundry), or even product features!."
                        />
                        : null
                }

            </motion.div>
        );
    }

};